import { useScrollReveal } from '../hooks/useScrollReveal';
import { Button } from './ui/button';
import { ExternalLink } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export const GoatsSection = () => {
  const [ref, isVisible] = useScrollReveal();
  const { t } = useLanguage();
  const image = '/images/goats.jpg';

  return (
    <section id="goats" className="relative py-20 bg-[#0A0A0A] overflow-hidden" ref={ref}>
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#C9A84C]/20 to-transparent" />
      <div className="max-w-7xl mx-auto px-6">
        <div className={`relative rounded-2xl overflow-hidden border border-[#C9A84C]/15 transition-all duration-1000 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-[0.98]'}`}>
          <div className="absolute inset-0"><img src={image} alt="Goats of Sports" className="w-full h-full object-cover" /><div className="absolute inset-0 bg-[#0A0A0A]/75 backdrop-blur-[2px]" /><div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A]/90 via-[#0A0A0A]/60 to-[#0A0A0A]/40" /></div>
          <div className="relative z-10 p-10 sm:p-16 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
            <div className="max-w-xl">
              <div className="flex items-center gap-3 mb-4"><div className="h-[1px] w-8 bg-[#C9A84C]" /><span className="text-[#C9A84C] text-sm font-medium tracking-[0.2em] uppercase">{t.goats.tagline}</span></div>
              <h2 className="text-3xl sm:text-4xl font-bold text-[#F5F0E8] mb-4 font-heading">{t.goats.headline} <span className="text-[#C9A84C]">{t.goats.headlineAccent}</span></h2>
              <p className="text-[#9A9590] text-base leading-relaxed">{t.goats.description}</p>
            </div>
            <Button className="bg-[#C9A84C] hover:bg-[#D4B85A] text-[#0A0A0A] font-semibold px-8 h-12 text-sm tracking-wide border-0 flex-shrink-0 gap-2">{t.goats.cta}<ExternalLink size={16} /></Button>
          </div>
        </div>
      </div>
    </section>
  );
};
